import type { HandoverDiscountStat } from "@/api/user/types/handover"
import { buildDiscountTypeStatisticsView, formatDiscountTypeDisplayAmount } from "@/features/reports/discountTypeStatistics"

export interface HandoverDiscountPrintRow {
  name: string
  count: string
  amount: string
}

export interface HandoverDiscountPrintView {
  rows: HandoverDiscountPrintRow[]
  totalAmount: string
}

export function formatHandoverDiscountAmount(discountAmount?: number): string {
  return formatDiscountTypeDisplayAmount(discountAmount)
}

export function buildHandoverDiscountPrintView(
  statistics?: HandoverDiscountStat[],
): HandoverDiscountPrintView {
  const view = buildDiscountTypeStatisticsView(statistics)
  return {
    rows: view.rows.map(item => ({
      name: item.name,
      count: String(item.count),
      amount: formatHandoverDiscountAmount(item.storedAmount),
    })),
    totalAmount: formatHandoverDiscountAmount(view.storedTotal),
  }
}
